import ajax from 'assets/js/ajax';
import qs from 'qs';

export async function login(param) {
    let res = await ajax.post('/login', qs.stringify(param));
    return res.data;
}

export async function validate() {
    let res = await ajax.get('/valid');
    return res.data;
}

export async function validatePwd(pwd) {
    let res = await ajax.post('/myaccount/valid/confirm/password', qs.stringify({ password: pwd }));
    return res.data;
}

export async function forbid() {
    let res = await ajax.get('/myaccount/forbid');
    return res.data;
}

export async function getCode(pwd) {
    let res = await ajax.post('/register/vcode', qs.stringify({ phone: pwd }));
    return res.data;
}
export async function forgetNumber(pwd) {
    let res = await ajax.post('/forgetloginpwd/vcode', qs.stringify({ phone: pwd }));
    return res.data;
}
export async function forgetLogin(pwd) {
    let res = await ajax.post('/forgetloginpwd', qs.stringify(pwd));
    return res.data;
}
export async function registerSubmit(pwd) {
    let res = await ajax.post('/register', qs.stringify(pwd));
    return res.data;
}



// WEBPACK FOOTER //
// ./src/api/system.js